module.exports = __webpack_public_path__ + "assets/img/10.f7b6d595.png";